import Vue from 'vue'
import BoardViewPage from '@/views/BoardViewPage'
import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);
Vue.config.productionTip = false;
new Vue({
  render: h => h(BoardViewPage)
}).$mount('#app')